import React from "react";
import { useNavigate } from "react-router-dom";
import DocumentSeriesAdmin from "./DocumentSeriesAdmin";

const AdminSpecsPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  return <DocumentSeriesAdmin onBack={handleBack} />;
};

export default AdminSpecsPage;
